import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'

import { api } from '@/api'
import { SSO_STATE_KEY } from '@/lib/sso'

export const Route = createFileRoute('/oauth/simluhtan/callback')({
  validateSearch: (search: Record<string, unknown>) => ({
    code: search.code as string | undefined | null,
    state: search.state as string | undefined | null,
    error: search.error as string | undefined | null
  }),
  loaderDeps: ({ search }) => ({
    code: search.code,
    state: search.state,
    error: search.error
  }),
  beforeLoad: ({ search }) => {
    if (search.error) {
      localStorage.removeItem(SSO_STATE_KEY)
      throw redirect({
        to: '/',
        search: { error: 'sso_failed' }
      })
    }

    if (!search.code || !search.state) {
      localStorage.removeItem(SSO_STATE_KEY)
      throw redirect({
        to: '/',
        search: { error: 'sso_failed' }
      })
    }

    const storedState = localStorage.getItem(SSO_STATE_KEY)
    if (!storedState || storedState !== search.state) {
      localStorage.removeItem(SSO_STATE_KEY)
      throw redirect({
        to: '/',
        search: { error: 'sso_failed' }
      })
    }
  },
  component: SSOCallbackPage
})

function SSOCallbackPage() {
  const { code, state } = Route.useSearch()
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const { mutate: exchangeCode } = useMutation({
    ...api.auth.ssoCallback(queryClient),
    onSuccess: () => {
      localStorage.removeItem(SSO_STATE_KEY)
      navigate({ to: '/dashboard', replace: true })
    },
    onError: () => {
      localStorage.removeItem(SSO_STATE_KEY)
      navigate({
        to: '/',
        replace: true,
        search: { error: 'sso_failed' }
      })
    }
  })

  useEffect(() => {
    if (code && state) {
      exchangeCode({ code, state })
    }
  }, [code, state, exchangeCode])

  return (
    <div className="flex h-screen items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-4">
        <div className="size-10 animate-spin rounded-full border-4 border-gray-200 border-t-primary" />
        <p className="text-sm text-gray-500">Memproses login SSO...</p>
      </div>
    </div>
  )
}
